import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginDataService } from './login-data.service';
import { LocalStorage } from '../util/localstorage.service';
import { User } from '../models/user.model';
import { LoginCredential } from '../models/login-credential.model';
import { AlertService } from '../util/alert/alert.service';
import { Constants } from '../util/constants';
import { version } from '../../../package.json';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	public appVersion: string = version

	@ViewChild('login_username') userNameInput: ElementRef;
	@ViewChild('login_password') passwordInput: ElementRef;

	public showPassword: boolean = false;
	public loginCredential: LoginCredential;
	public showAgreement: boolean = false;
	private user: User = new User()

	constructor(private router: Router, private ldService: LoginDataService, private alertService: AlertService) {
	}

	ngOnInit() {
		// Initializing the auth request.
		this.loginCredential = new LoginCredential();

	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.loginCredential.Email = this.userNameInput.nativeElement.value;
			this.loginCredential.Password = this.passwordInput.nativeElement.value;
		}, 1000);
	}

	public forgotPasswordEvent() {
		let randNum: number = Math.floor(Math.random() * 4) + 1
		this.alertService.clear()
		switch (randNum) {
			case 1:
				this.alertService.success('Sample SUCCESS alert message')
				break;
			case 2:
				this.alertService.error('Sample ERROR alert message')
				break;
			case 3:
				this.alertService.info('Sample INFO alert message')
				break;
			case 4:
				this.alertService.warn('Sample WARN alert message')
				break;
			default:
				break;
		}
	}

	public resetPasswordEvent() {
		this.alertService.clear()
		if (confirm("Are you sure you want to reset password?")) {
			if (this.userNameInput.nativeElement.value=="")
			{
				this.alertService.error('Invalid username')
			}
			else
			{
				let temploginCredential: LoginCredential = new LoginCredential();
				temploginCredential.Email = this.userNameInput.nativeElement.value;

				this.ldService.resetpassword(temploginCredential).subscribe(data => {
					this.alertService.info('New password has been sent to your email.')
				},
					error => {
						this.alertService.error('Email not registered in system.')
					});
			}

		}
	}

	public loginBtnClickEvent() {
		localStorage.clear();
		this.alertService.clear()
		this.ldService.getserviceversion().subscribe(version => {
			localStorage.setItem(LocalStorage.SERVICE_VERSION, JSON.stringify(version));
		},
		error => {
			this.alertService.error('Invalid username or password')
		});
		setTimeout(()=> {
			this.ldService.authenticate(this.loginCredential).subscribe(data => {
				this.user  = data
				if (this.user != null && this.user != undefined){
					localStorage.setItem(LocalStorage.LOGGED_USER, JSON.stringify(this.user));
					if(LocalStorage.redirectUrl){
            this.router.navigateByUrl(LocalStorage.redirectUrl);
          }else {
            if(this.user.UserRoleID == Constants.UserRoleID.SuperUser){
              this.router.navigateByUrl('landing');
            }
            else if(this.user.UserRoleID == Constants.UserRoleID.AdminUser){
              this.router.navigateByUrl('managepatients');
            } else{
              this.router.navigateByUrl('tbbo2therapyreport');
            }
          }

				}
				else
				{
					this.showAgreement = true
				}
			},
			error => {
				this.alertService.error('Invalid username or password')
			});
		}, 50);
	}

	// public acceptBtnClickEvent()
	// {
	// 	this.ldService.acceptagreement(this.user).subscribe(data => {
	// 		localStorage.setItem(LocalStorage.LOGGED_USER, JSON.stringify(this.user));
	// 		this.router.navigateByUrl('patientreports');
	// 	},
	// 		error => {
	// 			this.alertService.clear()
	// 			this.alertService.error('Error occured while saving data.')
	// 		});

	// }

	public rejectBtnClickEvent()
	{
		this.showAgreement = false
		localStorage.clear();
	}
}
